export const OctopusTypesConfig = {
  logError: (error: Error) => {
    console.log(error);
  },
};
